export * from './src/my-date-picker/my-date-picker.module';


// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/mydatepicker/index.ts